import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';

export default class TaskCheckbox extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    size: PropTypes.string,
    task: PropTypes.shape({
      completedAt: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func,
    // DEPRECATED: Called on click, not when the task state changed, so the name is misleading
    onTaskStateChange: PropTypes.func
  }

  handleClick = (e) => {
    e.stopPropagation();

    if (this.props.onTaskStateChange) {
      this.props.onTaskStateChange(this.props.task);
    }

    if (this.props.onClick) {
      this.props.onClick(this.props.task);
    }
  }

  render() {
    const size = this.props.size || "34px";
    const { className, task } = this.props;
    const completedStyle = {
      color: "#848F99",
      height: size,
      width: size,
      cursor: "pointer"
    };

    const incompleteStyle = {
      color: "white",
      height: size,
      width: size,
      cursor: "pointer",
      border: "2px solid #848F99",
      borderRadius: "20px"
    };

    const icon = task.completed ? faCheckCircle : faCircle;
    return (
      <div
        className={`icon ${className || ''}`}
        name="taskIcon"
        onClick={this.handleClick}
      >
        <FontAwesomeIcon icon={icon} size="sm" style={task.completed ? completedStyle : incompleteStyle}/>
      </div>
    );
  }
}
